<div class="searchbar-with-api-suggestions">
  <div class="searchbar-with-api-suggestions__search-on-enter-container">
    <ion-input
      class="searchbar-with-api-suggestions__search-input"
      [value]="searchText"
      [disabled]="isDisabled || false"
      [placeholder]="(placeholder ? placeholder : 'multi_select.Search') | translate"
      (ionChange)="onSearchInputChange($event)"
      (keyup.enter)="handleSearchEvent($event)"
    >
    </ion-input>

    <div class="searchbar-with-api-suggestions__search-cross-container">
      <span
        *ngIf="!showSuggestions || !searchResultsNotFound; else searchResultsPresent"
        class="searchbar-with-api-suggestions__search-text"
        (click)="handleSearchEvent($event)"
        >{{ 'multi_select.Search' | translate }}</span
      >

      <ng-template #searchResultsPresent>
        <ion-icon
          name="close-circle-outline"
          class="searchbar-with-api-suggestions__search-cross-icon"
          (click)="onClearSearchEvent()"
        ></ion-icon>
      </ng-template>
    </div>
  </div>

  <div *ngIf="searchResultsNotFound" class="searchbar-with-api-suggestions__invalid-msg">No results found!</div>

  <div
    *ngIf="showSuggestions"
    class="searchbar-with-api-suggestions__suggestions-container"
    (clickOutside)="handleOutsideClick()"
  >
    <div *ngIf="multiSelect; else singleSelect">
      <div class="searchbar-with-api-suggestions__suggestions">
        <ng-container *ngIf="virtualScroll && _searchAPIResults.length > 100; else normalContentLoad">
          <cdk-virtual-scroll-viewport
            [itemSize]="virtualScroll.itemSize"
            [minBufferPx]="virtualScroll.minBufferPx"
            [maxBufferPx]="virtualScroll.maxBufferPx"
            [ngStyle]="{ 'min-height': '300px' }"
          >
            <ng-container *cdkVirtualFor="let option of _searchAPIResults; let i = index">
              <div>
                <ion-item>
                  <ion-checkbox [(ngModel)]="option.isSelected" mode="ios"></ion-checkbox>
                  <ion-label class="searchbar-with-api-suggestions__label">
                    {{ option.displayText || option.value }}
                  </ion-label>
                </ion-item>
              </div>
            </ng-container>
          </cdk-virtual-scroll-viewport>
        </ng-container>
        <ng-template #normalContentLoad>
          <div *ngFor="let option of _searchAPIResults; let i = index">
            <ion-item>
              <ion-checkbox [(ngModel)]="option.isSelected" mode="ios"></ion-checkbox>
              <ion-label class="searchbar-with-api-suggestions__label">
                {{ option.displayText || option.value }}
              </ion-label>
            </ion-item>
          </div>
        </ng-template>
      </div>

      <div>
        <ion-row class="searchbar-with-api-suggestions__button-container">
          <ion-col>
            <ui-custom-button
              [btnTxt]="'filter.ClearAll' | translate"
              [buttonType]="'SECONDARY'"
              (clickEvent)="onClearAll()"
              [expand]="'block'"
            ></ui-custom-button>
          </ion-col>
          <ion-col>
            <ui-custom-button
              [btnTxt]="'multi_select.Apply' | translate"
              [buttonType]="'PRIMARY'"
              (clickEvent)="onApply()"
              [expand]="'block'"
            ></ui-custom-button>
          </ion-col>
        </ion-row>
      </div>
    </div>
    <ng-template #singleSelect>
      <ng-container *ngIf="virtualScroll && _searchAPIResults.length > 100; else normalSingleSelectContentLoad">
        <cdk-virtual-scroll-viewport
          [itemSize]="virtualScroll.itemSize"
          [minBufferPx]="virtualScroll.minBufferPx"
          [maxBufferPx]="virtualScroll.maxBufferPx"
          style="min-height: 300px"
        >
          <ng-container *cdkVirtualFor="let item of _searchAPIResults">
            <div (click)="onSuggestionSelection(item.value)" class="searchbar-with-api-suggestions__suggestions-items">
              {{ item }}
            </div>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </ng-container>
      <ng-template #normalSingleSelectContentLoad>
        <div
          *ngFor="let item of _searchAPIResults"
          (click)="onSuggestionSelection(item.value)"
          class="searchbar-with-api-suggestions__suggestions-items"
        >
          {{ item.displayText || item.value }}
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
